import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.css']
})
export class EditprofileComponent implements OnInit {

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  submittedpassword: boolean;
  successfullypassword: boolean;


  show: boolean;
  showsecurity: boolean;
  //Edit Get Values
  userColl: any = [];
  userroleColl: any = [];
  userid: number = 0
  emailreadonly: boolean = false
  isenablesecuritykey: boolean = false

  userBO: any = {}

  //pageColl:any=[];

  userform = new FormGroup({
    userid: new FormControl(0),
    username: new FormControl('', Validators.required),
    securitykey: new FormControl(''),
  });

  userpassform = new FormGroup({
    userid: new FormControl(0),
    pwd: new FormControl('', Validators.required),
    newpwd: new FormControl('', Validators.required),
    confirmpwd: new FormControl('', Validators.required),
  }, this.passwordMatchingValidatior);


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "User";

  constructor(private appService: DhukanDataService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.userform.reset();
      this.userpassform.reset();
      this.fnInitializeUser();


      this.userid = this.loginService.fnGetModUserId();

      if (this.userid > 0) {
        this.emailreadonly = true;
        this.fngetUser();
      }
      //  this.fngetUserrole();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.userid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeUser() {
    this.userform.setValue({
      userid: 0,
      username: '',
      securitykey: '',
    })

    this.userpassform.setValue({
      userid: 0,
      pwd: '',
      newpwd: '',
      confirmpwd: '',
    })
  }



  passwordMatchingValidatior(form: FormGroup): null {
    const password = form.controls['newpwd'].value;
    const confirmation = form.controls['confirmpwd'].value;

    if (!password || !confirmation) { // if the password or confirmation has not been inserted ignore
      return null;
    }

    if (confirmation.length > 0 && confirmation !== password) {
      confirmation.setErrors({ notMatch: true }); // set the error in the confirmation input/control
    }

    return null; // always return null here since as you'd want the error displayed on the confirmation input
  }

  //Get 
  fngetUser() {
    var data = {
      'userid': this.userid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getUser(data)
      .subscribe(
        (res) => {
          this.userColl = res.json().result;
          var editdata = this.userColl[0];

          this.userBO = editdata;

          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.userform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'userid': this.userid,
          'username': this.userform.get('username').value,
          'securitykey': this.userform.get('securitykey').value,
          'savetype': 'INFO',
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        if (this.userform.get('userid').value > 0) {
          //Update Department
          this.fnSetUser(data);
        }
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  fnValidateCurrentPassword() {

    if (this.userpassform.get('pwd')) {
      this.userpassform.controls['pwd'].setErrors(null);
    }

    if (this.userpassform.get('confirmpwd')) {
      this.userpassform.controls['confirmpwd'].setErrors(null);
    }


    const cuurentpassword = this.userpassform.controls['pwd'].value;
    const oldpassword = this.userBO.pwd;


    const password = this.userpassform.controls['newpwd'].value;
    const confirmation = this.userpassform.controls['confirmpwd'].value;


  

    if (cuurentpassword !== oldpassword) {
      this.userpassform.controls['pwd'].setErrors({ 'notfound': true });
      return false;
    }
    else if (confirmation.length > 0 && confirmation !== password) {
      this.userpassform.controls['confirmpwd'].setErrors({ 'notMatch': true });
      return false;   
    }
    else {
      return true;
    }

  }

  fnSavePasswordBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submittedpassword = true;
      this.successfullypassword = false;

      //Validate
      if (this.userpassform.valid) {

        if (this.fnValidateCurrentPassword() === false) {
          return;
        }

        this.saveloading = true;
        //Check
        var data = {
          'userid': this.userid,
          'pwd': this.userpassform.get('newpwd').value,
          'savetype': 'PASSWORD',
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        if (this.userform.get('userid').value > 0) {
          //Update Department
          this.fnSetUser(data);
        }
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }



  //Set
  fnSetUser(data) {

    this.appService.fnSetUserPassword(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The user has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.userid, data.username);

          this.fnCloseUser();
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseUser() {
    try {
      this.router.navigate(['/']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {

    this.userform.setValue({
      userid: deptBO.userid,
      username: deptBO.username,
      securitykey: deptBO.securitykey,
    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnShowpassword() {

    this.show = !this.show;
  }
  fnShowSecurity() {

    this.showsecurity = !this.showsecurity;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
